import {
  Flex,
  RadioTile,
  Text,
  IconNames,
  Icon,
  spaces,
  sizes,
} from '@electricjs/arc';

import { type StorefrontProductTypeGroup } from '@/types/storefront';

type TypeGroupRadioTileProps = {
  value: StorefrontProductTypeGroup;
  checked?: boolean;
  name: string;
  icons: IconNames[];
};

export const TypeGroupRadioTile = ({
  value,
  checked,
  name,
  icons,
}: TypeGroupRadioTileProps) => {
  return (
    <RadioTile
      id={`storefront-product-type-group-option-${value}`}
      value={value}
      checked={checked}
      borderRadius={sizes.size_8}
      customComponent={
        <Flex
          vertical
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          rowGap={spaces.space_s}
          padding={spaces.space_m}
          height="108px"
          width="154px">
          <Flex columnGap={spaces.space_xs}>
            {icons.map(iconName => {
              return <Icon key={iconName} icon={iconName} size="medium" />;
            })}
          </Flex>
          <Text
            variant={checked ? 'label-small' : 'body-2'}
            intent={checked ? 'brand' : undefined}>
            {name}
          </Text>
        </Flex>
      }
    />
  );
};
